import React from 'react';
import * as PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Row } from 'antd';
import pdf from './motorbike.jpg';

function ViewImage({ match }) {
  const images = [
    {
      name: 'pdf',
      src: pdf,
    },
  ];
  return (
    <Row type="flex" align="middle" justify="center">
      <img src={images.find(img => img.name === match.params.file).src} alt="{imported-file-code}" />
    </Row>
  );
}

ViewImage.propTypes = {
  match: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withRouter(ViewImage);
